import { getResolveContentQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute } from '@tanstack/react-router';
import { SubNavPageContainer } from 'src/components/page-container';
import { SpacePostDetailPage } from 'src/features/community-hub/components/space-post-detail-page';
import { ContentRouteProvider } from 'src/features/community-hub/hooks/use-content-route';

/**
 * Community post detail. Path: /community-hub/{programSlug}/{feedSlug}/posts/{postId}
 * Resolves the feed and provides the content-route context so the post's back /
 * tag navigation returns to the slug feed URL.
 */
export const Route = createFileRoute('/_protected/community-hub/$programSlug/$feedSlug/posts/$postId')({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      getResolveContentQueryOptions({ program: params.programSlug, module: params.feedSlug }),
    ),
  component: CommunityPostRoute,
});

function CommunityPostRoute() {
  const { programSlug, feedSlug, postId } = Route.useParams();
  const resolved = Route.useLoaderData();
  const feedId = resolved.module?.id ?? '';

  return (
    <ContentRouteProvider
      value={{ programId: resolved.program.id, programSlug, subSpaceId: feedId, subSpaceSlug: feedSlug }}
    >
      <SubNavPageContainer>
        <SpacePostDetailPage postId={postId} spaceId={feedId} />
      </SubNavPageContainer>
    </ContentRouteProvider>
  );
}
